import "./StepBar.style.scss";
import { useTranslation } from "react-i18next";

interface IStepBarComponentProps {
  step: number;
}
const StepBarComponent = ({ step }: IStepBarComponentProps) => {
  const { t } = useTranslation();
  return (
    <div className="stepBar">
      <div className={`box ${step === 1 ? "box-active" : "box-inactive"}`}>
        {step === 1 && <i className="step_number step_number-active">1</i>}
        {(step === 2 || step === 3) && (
          <i className="step_number step_number-done"></i>
        )}
        <span>{t("logIn.stepBar.step1")}</span>
      </div>
      <div className={`box ${step === 2 ? "box-active" : "box-inactive"}`}>
        {step === 1 && <i className="step_number step_number-inactive">2</i>}
        {step === 2 && <i className="step_number step_number-active">2</i>}
        {step === 3 && <i className="step_number step_number-done"> </i>}
        <span>{t("logIn.stepBar.step2")}</span>
      </div>
      <div className={`box ${step === 3 ? "box-active" : "box-inactive"}`}>
        {(step === 1 || step === 2) && (
          <i className="step_number step_number-inactive">3</i>
        )}
        {step === 3 && <i className="step_number step_number-active">3</i>}
        <span>{t("logIn.stepBar.step3")}</span>
      </div>
    </div>
  );
};
export default StepBarComponent;
